import { Tab } from "@headlessui/react";
import  {  useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import PastBookingsTable from "components/BookingsTable/PastBookingsTable";
import config from "config.json";
import { useNavigate } from "react-router-dom";
import useFetch from "hooks/useFetch";



const AccountSavelists = () => {
  
  const [reservas, setReservas] = useState([]);
  const [bookingError, setBookingError] = useState(false);
  const user_token = sessionStorage.getItem("user_token");
  const { data, isLoading, error, fetchData } = useFetch(
    'GET',
    `${config.backend_url}/setia/reservas/lista`,
    {},
    {
      'Content-Type': 'application/json',
      'SetiaAuthorization': `${user_token}`
    }
  );
  const router = useNavigate();

  const renderBookingError = () => {

    return (
      <div className="flex justify-center items-center text-center">
      <div>  
      <p className="text-red-500"> Lo sentimos ha ocurrido un error al cargar tus reservas.</p>
      <button onClick={() => router('/')} className="mt-3 ml-4  bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full ">Volver al inicio</button>
      </div>
      </div>)
      };


  const reservasOrdenadas = (reservas: any): any => {
    return reservas.sort((a: any, b: any) => 
            new Date(b.fecha_inicio).getTime() - new Date(a.fecha_inicio).getTime()
    );
  };
  useEffect(() => {
    if (data ) {

      const response = data as any

      setReservas(reservasOrdenadas(response.reservas));
    }
  }, [data]);

useEffect(() => {
  if (error) {
    setBookingError(true);
  }
}, [error]);

  useEffect(() => {
    setBookingError(false);
    fetchData()
  }, [])

  return (
    <div>
      <CommonLayout>
        { reservas.length > 0 && <PastBookingsTable reservas={reservas} /> }
        { bookingError && renderBookingError() } 
      </CommonLayout>
    </div>
  );
};

export default AccountSavelists;
